import register from '../register';

const key = 'amazon_connect';

class ConnectChat {

  constructor() {
    // check for previous embed so that we don't double-init Connect via
    // HMR while developing locally
    this.loaded = !!window.amazon_connect;

    this.config = Object.assign(
      {},
      JSON.parse(
        window.connect_config
        .replaceAll( '&quot;', '"' )
        .replaceAll( '&#x3D;', '=' )
      )
    );
  }


  launch() {
    const script = document.createElement('script');

    // prevent double init w/ hot module reload in dev, and also
    // sanity check that we have a valid Connect config
    if ( this.loaded || !Object.keys( this.config ).length ) {
      return;
    }

    // stub out global amazon_connect function
    const fn = window[ key ] = window[ key ] || function() {
      ( window[ key ].ac = window[ key ].ac || [] ).push( arguments );
    };

    script.id = this.config.widget_id;
    script.src = [
      'https://',
      this.config.script_subdomain,
      '.cloudfront.net/amazon-connect-chat-interface-client.js'
    ].join('');
    script.async = true;
    script.dataset.lazy = true;

    fn( 'styles', {
      iconType: 'CHAT',
      openChat: {
        color: '#ffffff',
        backgroundColor: '#4D5399'
      },
      closeChat: {
        color: '#ffffff',
        backgroundColor: '#4D5399'
      }
    });

    fn( 'snippetId', this.config.snippet_id );

    fn(
      'supportedMessagingContentTypes',
      [
        'text/plain',
        'text/markdown',
        'application/vnd.amazonaws.connect.message.interactive',
        'application/vnd.amazonaws.connect.message.interactive.response'
      ]
    );

    document.documentElement.appendChild( script );

    this.loaded = true;
  }
}

register( 'connect-chat', () => {
  const chat = new ConnectChat();

  chat.launch();
});

export default undefined;
